module.exports = __webpack_public_path__ + "img/2h.17ff2633.png";